export function mountStudioAurora(root = document) {
	root.querySelectorAll("[data-studio-aurora]").forEach(canvas => {
		if (canvas.dataset.mounted) return;
		canvas.dataset.mounted = "true";
		new StudioAurora(canvas);
	});
}

class StudioAurora {
	constructor(canvas) {
		this.canvas = canvas;
		this.context = canvas.getContext("2d");
		if (!this.context) return;
		this.hero = canvas.closest(".studio-hero");
		this.motion = matchMedia("(prefers-reduced-motion: reduce)");
		this.pointer = 0.5;
		this.visible = false;
		this.frame = null;
		this.started = performance.now();
		this.resize = new ResizeObserver(() => this.fit());
		this.resize.observe(this.hero);
		this.observer = new IntersectionObserver(([entry]) => {
			this.visible = entry.isIntersecting;
			this.update();
		});
		this.observer.observe(this.hero);
		this.hero.addEventListener("pointermove", event => {
			this.pointer = (event.clientX - this.hero.getBoundingClientRect().left) / this.hero.clientWidth;
		}, { passive: true });
		this.motion.addEventListener("change", () => this.update());
		document.addEventListener("visibilitychange", () => this.update());
		new MutationObserver(() => this.update()).observe(document.documentElement, {
			attributes: true, attributeFilter: ["data-studio-motion"],
		});
	}

	fit() {
		// A bounded canvas keeps the decorative effect inexpensive on phones.
		this.canvas.width = Math.min(this.hero.clientWidth, 1000);
		this.canvas.height = Math.min(this.hero.clientHeight, 650);
		this.draw(0);
		this.update();
	}

	update() {
		if (this.frame !== null) cancelAnimationFrame(this.frame);
		this.frame = null;
		if (!this.visible || document.hidden || this.motion.matches || document.documentElement.dataset.studioMotion === "off") {
			this.draw(0);
			return;
		}
		this.frame = requestAnimationFrame(time => this.animate(time));
	}

	animate(time) {
		this.draw((time - this.started) / 1000);
		this.frame = requestAnimationFrame(next => this.animate(next));
	}

	draw(time) {
		const { width, height } = this.canvas;
		const ctx = this.context;
		ctx.clearRect(0, 0, width, height);
		ctx.globalCompositeOperation = "screen";
		for (let band = 0; band < 5; band++) {
			const gradient = ctx.createLinearGradient(0, height * 0.25, 0, height);
			gradient.addColorStop(0, "rgba(23, 105, 210, 0)");
			gradient.addColorStop(0.55, `rgba(29, ${100 + band * 18}, 245, 0.13)`);
			gradient.addColorStop(1, "rgba(38, 168, 222, 0.04)");
			ctx.fillStyle = gradient;
			ctx.beginPath();
			ctx.moveTo(0, height);
			for (let x = 0; x <= width + 12; x += 12) {
				const phase = x / width * 5 + time * 0.16 + band * 0.7;
				const y = height * (0.64 + Math.sin(phase) * 0.16 + Math.cos(phase * 1.7) * 0.07)
					+ (this.pointer - 0.5) * Math.sin(x / width * Math.PI) * 24;
				ctx.lineTo(x, y);
			}
			ctx.lineTo(width, height);
			ctx.closePath();
			ctx.fill();
		}
	}
}
